export default {
    root: {
        borderRadius: '8px !important',
        textAlign: 'start'
    }
};